export default {
        
}



// WEBPACK FOOTER //
// ./src/reducers/index.js